export class Customization {
  id: string;
  name: string;
  clientId: string;
  clientName: string;
}
